import { useContext } from 'react';

import { useSelector } from 'react-redux';

import { useQueries } from '@tanstack/react-query';
import { format, isAfter } from 'date-fns';

import * as ScenarioStore from '@asteria/datalayer/stores/scenarios';

import { ForecasterContext } from '../../context';
import { mergeOperations } from '../../utils/operations';

export function useHeaderData() {
	const { onSubmit } = useContext(ForecasterContext);

	const { dataloader } = useContext(ForecasterContext);

	const scenarioName = useSelector(
		(store) => ScenarioStore.selectors.sourceScenarioData(store)?.name,
	);

	const queries = useQueries({
		queries: [
			{
				queryKey: ['accountbalance'],
				queryFn: async () => {
					return onSubmit?.('accountbalance:fetch', {
						range: 'MONTH',
						fromDate: format(new Date(), 'yyyy-MM-01'),
						fields: `
							date
							balanceAtEndOfPeriod
							balanceAtStartOfPeriod
							deposits
							withdrawals
						`,
					});
				},

				refetchOnMount: true,
				refetchOnReconnect: false,
				refetchOnWindowFocus: false,
			},
			{
				queryKey: ['forecaster', 'scenario', 'header', scenarioName],
				queryFn: async ({ meta }) => {
					return await onSubmit?.('forecast:fetch:scenario', {
						scenarioName: scenarioName,
						dataloader: meta?.dataloader,
						fields: `
							id
							name
							operations(includeParent: true) {
								_id
								op
								uuid
								payload {
									total
									paymentDate
									type
									tags
									description
									targetId
								}
							}
						`,
					});
				},
				// select: (response) => response?.operations ?? [],
				meta: { dataloader },
				keepPreviousData: true,

				refetchOnMount: true,
				refetchOnReconnect: false,
				refetchOnWindowFocus: false,

				placeholderData: null,

				cacheTime: 0,
				staleTime: 0,
			},
		],
	});

	const [history, scenario] = queries;

	return {
		loading: queries.some(({ isFetching }) => isFetching),
		data: mergeOperations(scenario?.data?.operations ?? []).reduce(
			(acc, { payload: { type, total, paymentDate } }) => {
				if (type === 'DEPOSIT') {
					acc.total += total;
				} else {
					acc.total -= total;
				}

				if (
					!acc.endDate ||
					isAfter(new Date(paymentDate), new Date(acc.endDate))
				) {
					acc.endDate = paymentDate;
				}

				return acc;
			},
			{
				total: history?.data?.[0]?.balanceAtStartOfPeriod ?? 0,
				endDate: null,
			},
		),
	};
}
